import { render, staticRenderFns } from "./CreateAcquirerAffiliationModal.vue?vue&type=template&id=34db0828"
import script from "./CreateAcquirerAffiliationModal.vue?vue&type=script&lang=js"
export * from "./CreateAcquirerAffiliationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "../affiliations.translation.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2F_work%2Fdash-webapp%2Fdash-webapp%2Fsrc%2Fviews%2FSettings%2FAffiliations%2Fcomponents%2FCreateAcquirerAffiliationModal.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./CreateAcquirerAffiliationModal.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports